import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResponseService {
  private response: BehaviorSubject<{
    msg: string;
    responseCode?: string;
    attemptedEmail?: string | null;
  }> = new BehaviorSubject<{ msg: string; responseCode: string; attemptedEmail?: string | null }>({
    msg: '',
    responseCode: '',
    attemptedEmail: null,
  });

  setResponse(msg: string, responseCode: string, attemptedEmail: string | null = null) {
    this.response.next({ msg, responseCode, attemptedEmail });
  }

  getResponse(): Observable<{
    msg: string;
    responseCode?: string;
    attemptedEmail?: string | null;
  }> {
    return this.response.asObservable();
  }
}
